<div class="d-flex justify-content-center justify-content-md-start">
  <div class="d-flex flex-column flex-md-row">
    <a
      class="btn btn-primary mt-2"
      data-e2e="add-contract"
      [href]="viewModel.primaryButton.link | link: ParamsUtils.cidMap(viewModel.cid) | async"
      (click)="doClickPrimaryButtonLink(); (false)"
      [ecmDisabledAction]="isDisabledEclairForbiddenLink | async"
    >
      {{ viewModel.primaryButton.label }}
    </a>
    <a
      class="o-link-arrow mt-2 ml-md-2 ml-0 pt-0 pt-md-1 text-center"
      [href]="viewModel.secondaryButton.link | link: ParamsUtils.cidMap(viewModel.cid) | async"
      (click)="doClickSecondaryButtonLink(); (false)"
      >{{ viewModel.secondaryButton.label }}</a
    >
  </div>
</div>
